<template>
     <div
        :id="advanced.cssId"
        :class="['spacer', advanced.cssClasses, addedClass, responsiveClasses]"
        :style="outerStyle" >

        <label class="sp-label" :style="labelStyle">
          {{ basic.label || 'Label' }}
        </label>

	     <div class="inner-spacer" :style="style"></div>
    </div>
</template>

<script>
import {boxShadow, fontProps, getPadding} from "@/modules/page-editor/src/utils/props";

export default {
    name: 'FormSpacer',
    props: ['details', 'addedClass'],
    computed: {
        basic() {
            return this.details.attributes.basic
        },
        advanced() {
            return this.details.attributes.advanced
        },
        responsive() {
            return this.details.responsive
        },
        responsiveClasses() {
            let c = '';
            if (!this.responsive) return '';
            if (!this.responsive.desktop) c = 'no-desktop';
            if (!this.responsive.mobile) c += ' no-mobile';
            if (!this.responsive.tablets) c += ' no-tablet';
            return c;
        },
	    outerStyle() {
		    return {
			    margin: getPadding(this.basic.margin),
		    	padding: getPadding(this.basic.padding),
		    }
	    },
	    labelStyle() {
		    let margin = null;
		    let a = this.basic.font ? this.basic.font.textAlign || 'left' : 'left'
		    if (a==='center') margin = '0 auto';
		    else if (a==='right') margin = '0 0 0 auto';

		    return {
			    ...fontProps(this.basic.font),
			    margin
		    }
	    },
      style() {
        return {
            borderTopWidth: this.basic.widthNumber ? this.basic.widthNumber.number + 'px' : '1px',
            borderTopColor: this.basic.color ? this.basic.color : '#D5E5FF',
            borderTopStyle: this.basic.style ? this.basic.style : 'solid',
            boxShadow: boxShadow(this.basic.shadows),
        };
      }
    },
}
</script>
